module.exports = __webpack_public_path__ + "img/order.70eb7fab.png";